// 표 머리의 정렬 산수 — 어느 열을 어느 방향으로 세우는지만 알면 정해진다. 세우는 일은 서버가 한다(목록의 쪽).
//
// 같은 머리를 세 번 누르면 정렬이 풀려 서버의 기본 순서로 돌아간다 — 기본 순서를 세우는 머리가 없으니
// 풀 길이 없으면 한 번 누른 뒤로는 기본 순서를 다시 볼 수 없다.

export type SortDir = 'asc' | 'desc'
export type Sort<K extends string> = { key: K; dir: SortDir }

/** 머리를 눌렀을 때의 다음 정렬. 다른 머리는 오름차순에서 시작하고, 같은 머리는 내림차순 다음에 풀린다(`null`). */
export function nextSort<K extends string>(cur: Sort<K> | null, key: K): Sort<K> | null {
  if (cur?.key !== key) return { key, dir: 'asc' }
  return cur.dir === 'asc' ? { key, dir: 'desc' } : null
}

/** 머리의 `aria-sort`. 지금 정렬한 머리에만 선다. */
export function ariaSort<K extends string>(cur: Sort<K> | null, key: K): 'ascending' | 'descending' | undefined {
  if (cur?.key !== key) return undefined
  return cur.dir === 'asc' ? 'ascending' : 'descending'
}
